import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/image_136-removebg-preview.png";
import { getPartners } from "../Common/apis";
import Loader from "../Loader/Loader";
import micro from '../Assets/Microsoft.jpg'
import aws from '../Assets/aws.png'
import azure from '../Assets/Azure.png'
import gcp from '../Assets/Gcp.png'
import tableu from '../Assets/Tableau.png'
import pmp from '../Assets/pmp.svg'
import inf from '../Assets/informatica.png'
import talemd from '../Assets/TalendLogoCoral.png'
import powerbi from '../Assets/Powerbi.png'
import ub from '../Assets/unnamed.jpg'
import OracleSymbol from '../Assets/Oracle-Symbol.png'
import mysql from '../Assets/mysql.png'
import looker from '../Assets/looker.png'
import sigmabi from '../Assets/Sigma.webp'
import openai from '../Assets/openai.webp'
import apistraining from '../Assets/apistraining.png'
import dasa from '../Assets/dasa.png'
import fermion from '../Assets/Fermion.jpg'
import snowflake from '../Assets/snowflake.png'
import fivetran from '../Assets/fivetran.webp'
import redhat from '../Assets/redhat.png'
import Cisco from '../Assets/Cisco-logo.png'
import salesforce from '../Assets/salesforce.png'
import sap from '../Assets/sap.jpg'
import com from '../Assets/comptia.webp'














function Partners() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log(data);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await getPartners();
        setData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);
const items = [
  {
    img: micro,
    title: "Microsoft’s flagship product, Windows, is the most widely used operating system for personal and professional computers across the globe."
  },
  {
    img: aws,
    title: "With millions of active customers, AWS powers some of the most popular websites, startups, enterprises, and government agencies worldwide."
  },
  {
    img: azure,
    title: "Azure supports a wide range of programming languages, frameworks, and operating systems, offering hybrid capabilities, intelligent solutions, and enterprise-grade cloud infrastructure."
  },
  {
    img: gcp,
    title: "GCP is known for its high-performance infrastructure, AI and machine learning tools, and data analytics capabilities, making it ideal for startups to large enterprises."
  },
  {
    img: tableu,
    title: "Founded in 2003 and acquired by Salesforce in 2019, Tableau empowers users across industries to make data-driven decisions using visual analytics."
  },
  {
    img: pmp,
    title: "PMP is a globally recognized project management certification that demonstrates a professional’s ability to lead and manage projects effectively."
  },
  {
    img: inf,
    title: "Informatica is a leading provider of data integration and management solutions, helping organizations connect, manage, and analyze data effectively."
  },
  {
    img: talemd,
    title: "Talend is a cloud-based data integration platform offering tools for data preparation, data quality, and data governance."
  },
  {
    img: powerbi,
    title: "Power BI is a business analytics service by Microsoft that provides interactive visualizations and business intelligence capabilities with a user-friendly interface for creating reports and dashboards."
  },
  {
    img: ub,
    title: "Pentaho is a data integration and business analytics platform that provides tools for data preparation, reporting, and analysis."
  },
  {
    img: OracleSymbol,
    title: "Oracle is a multinational computer technology corporation offering a comprehensive suite of software, hardware, and cloud solutions for businesses."
  },
  {
    img: mysql,
    title: "MySQL is an open-source relational database management system widely used for web applications and data storage."
  },
  {
    img: looker,
    title: "Looker is a business intelligence and data analytics platform that provides tools for data exploration, visualization, and reporting."
  },
  {
    img: sigmabi,
    title: "Sigma BI is a data analytics platform that enables teams to explore, analyze, and visualize data using a collaborative spreadsheet interface."
  },
  {
    img: openai,
    title: "OpenAI is an artificial intelligence research organization that aims to ensure that AGI (Artificial General Intelligence) benefits all of humanity."
  },
  {
    img: fermion,
    title: "Fermion is a data analytics platform that provides tools for data exploration, visualization, and reporting." // (If "Fermion" is fictional or internal, clarify)
  },
  {
    img: apistraining,
    title: "APIs Training is a platform offering courses and resources for learning about APIs, data integration, and development best practices."
  },
  {
    img: dasa,
    title: "DASA is a global organization that provides training and certification programs for DevOps and agile professionals." // Assuming you meant DASA (DevOps Agile Skills Association)
  },
  {
    img: snowflake,
    title: "Snowflake is a cloud-based data warehousing platform that provides tools for scalable data storage, processing, and analytics."
  },
  {
    img: redhat,
    title: "Red Hat is a leading provider of open-source software solutions, including Linux operating systems, cloud computing, and container technologies."
  },
  {
    img: Cisco,
    title: "Cisco is a multinational technology corporation that designs, manufactures, and sells networking hardware, telecommunications equipment, and IT services."
  },
  {
    img: salesforce,
    title: "Salesforce is a cloud-based customer relationship management (CRM) platform that provides tools for sales, marketing, and customer service."
  },
  {
    img: sap,
    title: "SAP is a multinational software corporation that develops enterprise software to manage business operations and customer relationships."
  },
  {
    img: com,
    title: "CompTIA is a non-profit trade association that provides IT certifications and training programs for IT professionals."
  }
];

  return (
    <>
      <div className="main-div">
        <Navbar />
        <div className=" meet-partner-div">
          <div className="meet-partner-div-left">
            <h3
              style={{
                fontFamily: "DM Serif Text, serif",
                letterSpacing: "-0.32px"
              }}
              // className="font-[400] sm:text-[90px] text-[40px] sm:leading-[119px] leading-[40px] text-[#263238]"
              className="meetOur-text"
            >
              <i>Meet Our</i>
            </h3>
            <h3
              style={{
                fontFamily: "DM Serif Text, serif",
                letterSpacing: "-0.32px"
              }}
              // className="font-[400] pl-[222px] sm:text-[90px] text-[40px] sm:leading-[119px] leading-[40px] text-[#6953A3]"
              className="Partners-text"
            >
              <i>Tool Techbelt</i>
            </h3>
            <img src="/assets/home/vector1.svg" className="pt-[60px]" alt="" />
          </div>
          <div className="meet-partner-div-right">
            {/* <div className="haxa-gon"> */}
              {loading ? (
                // <p>Loading...</p>
                <Loader />
              ) : error ? (
                <p>Error: {error}</p>
              ) : (
                <div className="haxa-gon">
                  {(() => {
                    {/* array dalna h */}
                    const total = items.length;
                    const first = Math.max(1, Math.floor(total / 3) - 1);
                    const second = Math.floor(total / 3);
                    const third = total - (first + second);

                    const pattern = [first, second, third];
                    const rows = [];
                    let index = 0;

                    for (let i = 0; i < pattern.length; i++) {
                      const count = pattern[i];
                      const row = items.slice(index, index + count);
                      rows.push(row);
                      index += count;
                    }

                    return rows.map((row, i) => (
                      <div
                        key={i}
                        className="flex justify-center  flex-col  gap-4"
                        style={{
                          gap: "3rem !important",                           
                        }}
                      >
                        {row.map((partner, j) => (
                          <div key={j} className="hexagon-card " >
                          <div className="new-hax flex items-center justify-center bg-white ">

                            <img
                              src={partner.img || "/assets/home/item1.svg"}
                              className=""
                              alt="partner"
                              
                            />
                          </div>

                            <div className="hover-hexagon-card">
                              <p className="max-w-[140px] w-full font-[400] text-[12px] text-center text-white">
                                {partner.title ||
                                  "edForce has been supporting our business..."}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ));
                  })()}
                </div>
              )}

              {/* <div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
                <div className="hexagon-card">
                  <img
                    src="/assets/home/item1.svg"
                    className="h-[250px] w-[220px]"
                    alt="item"
                  />
                  <div className="hover-hexagon-card">
                    <p className="max-w-[140px] w-full font-[400] text-[12px]  text-center text-[#FFFFFF]">
                      edForce has been supporting our business and delivering
                      successful training sessions for various Internal
                      projects. They are reliable, thorough, available, good
                      communicators, and friendly!{" "}
                    </p>
                  </div>
                </div>
              </div> */}
              {/* <Hexagon text="1" /> */}
            {/* </div> */}
          </div>
        </div>
        {/* <div className="partner">
          <div className="partner-left">
            <h3>
              <i>Meet Our</i>
            </h3>
            <h2>
              <i>Partners</i>
            </h2>
          </div>
          <div className="partner-right">
            <div className="haxagon-div">
              <div className="haxagon">
                <img src={img} />
              </div>
              <div className="haxagon">
                <img src={img} />
              </div>
            </div>
            <div className="haxagon-div">
              <div className="haxagon">
                <img src={img} />
              </div>
              <div className="haxagon">
                <img src={img} />
              </div>
              <div className="haxagon">
                <img src={img} />
              </div>
            </div>
            <div className="haxagon-div">
              <div className="haxagon">
                <img src={img} />
              </div>
              <div className="haxagon">
                <img src={img} />
              </div>
              <div className="haxagon">
                <img src={img} />
              </div>
              <div className="haxagon">
                <img src={img} />
              </div>
            </div>
          </div>
        </div> */}
        <Footer />
      </div>
    </>
  );
}

export default Partners;

const Hexagon = ({ text }) => {
  return (
    <div className="hexagon-wrapper">
      <div className="hexagon">{text}</div>
    </div>
  );
};
